import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import * as Sentry from "@sentry/angular";

Sentry.init({
  dsn: "https://914dd4194f770c462feee4232e4172cb@o4508066918432768.ingest.us.sentry.io/4508066921512960",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost"
    , /^https:\/\/app-cge-hzz-api-dev-eastus-001.azurewebsites\.net\/api/
    , /^https:\/\/app-cge-hzz-api-qa-eastus-001.azurewebsites\.net\/api/
    , /^https:\/\/app-cge-hzz-api-prod-eastus-001.azurewebsites\.net\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
